import { render, staticRenderFns } from "./ModalDespachando.vue?vue&type=template&id=3981ece5&"
import script from "./ModalDespachando.vue?vue&type=script&lang=js&"
export * from "./ModalDespachando.vue?vue&type=script&lang=js&"
import style0 from "./ModalDespachando.vue?vue&type=style&index=0&id=3981ece5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports